<template>
  <div class="text-center cont-boton--pse" @click="openPage" >
    <img src="../assets/img/logo-pse.png" alt="" class="icono-pse--boton">
    <div color="primary" x-small class="cont-btn-realizarpago">Realizar <br> pagos</div>
  </div>
</template>
<script>
export default {
  name: 'botonPagoPSE',
  data () {
    return {
    }
  },
  methods: {
    openPage () {
      window.location.href = 'https://stage.eaav.gov.co/consulta_pago'
      // this.$router.push({name:'pagodefactura'})
    }
  }
}
</script>
<style lang="scss" scoped>
.cont-boton--pse{
  background: #2B5AC4;
  border-radius: 10px 0px 0px 10px;
  box-shadow: 0 0 10px rgba($color: #000000, $alpha: .8);
  padding: 10px;
  cursor: pointer;
  .icono-pse--boton{
    width: 80px;
  }
  .cont-btn-realizarpago{
    color: #FFFF;
    font-size: 11pt;
    line-height: 10pt;
  }
}

</style>
